<div [formGroup]="form">
  <div class="questions_content mt-4 mx-4">
    <div class="title_progress m-3">
      <h3 class="h3 mb-0">Select the recipients</h3>
      <p class="tagline">
        If you are not sure, no problem, you can change this later.
      </p>
    </div>
    <div class="mx-3" *ngIf="myFamilyInfo">
      <form action="#" method="post">
        <div
          class="family_recipient_wrapper"
          *ngIf="myFamilyInfo?.length; else noFamily"
          style="max-width: 500px;
          margin: 0 auto;"
        >
          <div class="family_recipient mt-5" style="
          border-radius: 12px;
          border: 1px solid rgba(0,9,57,.1);
          background: rgba(0,9,57,.04);
          max-width: 500px;
          max-height: 400px;
          overflow-y: auto;
          margin: 0 auto;
          padding: 10px;">
            <div
              class="single_family_member d-flex justify-content-between"
              *ngFor="let c of myFamilyInfo; index as i"
              style="border-radius: 8px;
              border: 1px solid rgba(0,9,57,.1);
              background: #fff;
              padding: 8px 7px;
              margin: 0 0 12px;"
            >
              <div class="recipient-name"
              style="display: flex;
              align-items: flex-end;
              gap: 15px;"
              >
                <img
                  class="profile_img"
                  *ngIf="c.user?.profilePhoto; else cprofileImage"
                  src="{{ blobUrl }}/profile/{{
                    c.user?.profilePhoto ?? 'profile.png'
                  }}"
                  src="/assets/images/recipient-profile.svg"
                  alt="{{ c.user?.firstName?.charAt(0) }}"
                  style="width: 20px;
                  height: 20px;
                  border-radius: 50%;
                  background: #03115c;
                  font-size: 14px;
                  color: #fff;
                  text-align: center;
                  display: inline-block;
                  margin-right: 10px;"
                />
                <ng-template #cprofileImage>
                  <div class="profileImage">
                    {{ c.user?.firstName?.charAt(0) }}
                  </div>
                </ng-template>
                <label class="family-member-name mb-0" for="check{{ i }}">
                  {{
                    c.fullName ||
                      c.user?.firstName || "" + " " + c.user?.lastName || ""
                  }}</label
                >
              </div>
              <div class="recipient-checkbox">
                <div class="form-check">
                  <input
                    class="form-check-input checkbox_btn"
                    type="checkbox"
                    id="check{{ i }}"
                    [checked]="checked(c.user?.id)"
                    name="option{{ i }}"
                    (change)="addFamilyMember(c.user, $event.target.checked)"
                  
                  />
                </div>
              </div>
            </div>
          </div>
          <!--select all familymembers-->
          <div class="select_family_members_feild my-3">
            <div class="form-group "
            style="font-size: 14px;
            color: #9ca3af;
            box-shadow: none;
            border-radius: 8px;
            border: 1px solid #d9d9d9;
            padding: 10px 20px;
            display: flex;
            align-items: center;
            gap: 10px;">
              <div class="form-check">
                <input
                  class="form-check-input checkbox_btn"
                  type="checkbox"
                  (change)="addAll($event.target.checked)"

                />
              </div>
              <label for="select_all" class="mb-0"
                >Select all my family members</label
              >
            </div>
          </div>
        </div>
        <ng-template #noFamily>
          <p>
            You have no family members yet.<a routerLink="/myfamily"
              >Add Family member</a
            >
          </p>
        </ng-template>
      </form>
    </div>
    <div *ngIf="!myFamilyInfo && !ProfessionalInfo">
      <div class="m-3">
        <div class="recipient_form_wrapper mt-4">
          <div class="reciptent_form">
            <ng-container class="fc_form m-3">
              <div class="single_form_feild">
                <div class="form-group">
                  <label for="msg_title" class="form-label">First name</label>
                  <input
                    type="text"
                    class="user form-control"
                    placeholder="First name"
                    required
                    formControlName="firstName"
                  />
                  <div class="valid-feedback">Valid.</div>
                  <div class="invalid-feedback">
                    Please fill out this field.
                  </div>
                </div>
              </div>

              <div class="single_form_feild">
                <div class="form-group">
                  <label for="msg_title" class="form-label">Last name</label>
                  <input
                    type="text"
                    class="user form-control"
                    formControlName="lastName"
                    placeholder="Last name"
                  />
                  <div class="valid-feedback">Valid.</div>
                  <div class="invalid-feedback">
                    Please fill out this field.
                  </div>
                </div>
              </div>

              <div class="single_form_feild">
                <div class="form-group">
                  <label for="msg_title" class="form-label"
                    >Email Address</label
                  >
                  <input
                    type="email"
                    formControlName="email"
                    class="user form-control"
                    placeholder="Email-id"
                    maxlength="50"
                    formControlName="email"
                  />
                  <div class="valid-feedback">Valid.</div>
                  <div class="invalid-feedback">
                    Please fill out this field.
                  </div>
                </div>
              </div>

              <div class="single_form_feild">
                <label for="msg_title" class="form-label">Phone Number</label>
                <div class="form-group">
                  <app-phone-input [form]="form"></app-phone-input>
                  <div class="valid-feedback">Valid.</div>
                  <div class="invalid-feedback">
                    Please fill out this field.
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="mx-3" *ngIf="ProfessionalInfo">
      <form action="#" method="post">
        <div
          class="family_recipient_wrapper"
          *ngIf="ProfessionalInfo?.length; else noFamily"
          style="max-width: 500px;
          margin: 0 auto;"
        >
          <div class="family_recipient mt-5" style="
          border-radius: 12px;
          border: 1px solid rgba(0,9,57,.1);
          background: rgba(0,9,57,.04);
          max-width: 500px;
          max-height: 400px;
          overflow-y: auto;
          margin: 0 auto;
          padding: 10px;">
            <div
              class="single_family_member d-flex justify-content-between"
              *ngFor="let c of ProfessionalInfo; index as i" style="border-radius: 8px;
              border: 1px solid rgba(0,9,57,.1);
              background: #fff;
              padding: 8px 7px;
              margin: 0 0 12px;"
            >
              <div class="recipient-name" style="display: flex;
              align-items: flex-end;
              gap: 15px;">
                <img
                  class="profile_img"
                  *ngIf="c.coverPhoto; else cprofileImage2"
                  src="{{ blobUrl }}/profile/{{
                    c?.profilePhoto ?? 'profile.png'
                  }}"
                  src="/assets/images/recipient-profile.svg"
                  alt="{{ c?.firstName?.charAt(0) }}" style="width: 20px;
                  height: 20px;
                  border-radius: 50%;
                  background: #03115c;
                  font-size: 14px;
                  color: #fff;
                  text-align: center;
                  display: inline-block;
                  margin-right: 10px;"
                />
                <ng-template #cprofileImage2>
                  <div class="profileImage">
                    {{ c?.firstName?.charAt(0) }}
                  </div>
                </ng-template>
                <label class="family-member-name mb-0" for="check{{ i }}">
                  {{ c?.firstName }} {{ c?.lastName }}</label
                >
              </div>
              <div class="recipient-checkbox">
                <div class="form-check">
                  <input
                    class="form-check-input checkbox_btn"
                    type="checkbox"
                    id="check{{ i }}"
                    [checked]="checked(c?.id)"
                    name="option{{ i }}"
                    (change)="addFamilyMember(c, $event.target.checked)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ng-template #noFamily>
          <p>You have no TPA members yet.</p>
        </ng-template>
      </form>
    </div>
  </div>
</div>

<div class="footer-buttons d-flex justify-content-between py-4 px-4 mb-4">
  <button type="button" class="border_btn" (click)="goBack()">Back</button>
  <button type="button" class="primary_btn" (click)="share(shareType)">
    {{ shareType ? "Share" : "Next" }}
  </button>
</div>
